export const environment = {
  production: true,
  internalBase: 'https://uiprod.nbrc.org/',
  portalApiBaseUrl: 'https://securewebapi.nbrc.org/api/practitioner/',
  commonApiBaseUrl: 'https://securewebapi.nbrc.org/api/common/',
  debugMode: false,
  messageCenterBaseUrl: 'https://mcprodapi.nbrc.org',
  messageCenterAppKey: 'JPSjF9oqgCx34J8G',
  messageCenterAppSecret: 'v8CO5a1nea8QU4k4f39PSpNU02a1kkf348x3pg5tnGCmMMHsTRQK5nsAOgs9YLxB',

  clientKey: '3QLdDs5vMPjL7k9mrsC3KWz2ry3BzApkh8Td8t9BuWL6n7DAmy2jgdJXW3J2qhGV',
  acceptJs: 'https://js.authorize.net/v1/Accept.js',
  apiLogin: 'NBRC009',


  externalLinks: {
    nbrcHome: 'https://NBRC.org/',
    purchaseSAE: 'https://NBRC.org/resources/sae',
    practiceExam: 'https://NBRC.org/Free-Practice-Exams',
    contentOutlines: 'https://NBRC.org/resources/contentoutlines',
    candidateHandbook: 'https://www.nbrc.org/candidate-handbook',
    privacyPolicy: 'https://NBRC.org/privacy-statement/',
    termsOfUse: 'https://www.nbrc.org/terms-of-use/',
    contactUs: 'https://NBRC.org/contact'
  }
};
